import { ConfigType } from 'config-type'

const configOverwrite: Partial<ConfigType> = {
  prismicPath: `https://${process.env.REACT_APP_PRISMIC_REPO_NAME}.cdn.prismic.io/api/v2`,
  showLegalInsideMenu: true,
  modules: ['Menu', 'Main'],
  topBarButtons: {
    desktop: ['Glossar'],
    phone: [],
  },
  landingPageRoute: '/intro',
  prismicModelsNamesMap: {
    page: 'chapter',
    section: 'subchapter',
    legal: 'imprint-sources-rights',
    impressumSlug: 'impressum',
    quellenSlug: 'text--und-bildquellenverzeichnis',
    dataPrivacySlug: 'datenschutz',
    subcontentNamesArray: [
      'fullscreen_subcontent_image',
      'fullscreen_subcontent_text',
      'fullscreen_subcontent_gallery',
      'fullscreen_subcontent_decision',
      'fullscreen_subcontent_video',
      'fullscreen_subcontent_work',
    ],
  },
  videoCustomization: { showMeta: true },
  stickyBackgroundHasFixedWidth: true,
  sectionTextBoxWidth: 1000,
}

export default configOverwrite
